import script from "./button-v2.vue?vue&type=script&setup=true&lang=ts"
export * from "./button-v2.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__